/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Create_Guild_Expressions_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to add custom emojis, stickers and sounds in this server." |
*
* @param {Leveling_Perm_Create_Guild_Expressions_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_create_guild_expressions_hint = /** @type {((inputs?: Leveling_Perm_Create_Guild_Expressions_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Create_Guild_Expressions_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам добавлять на этот сервер свои эмодзи, стикеры и звуки.")
	return /** @type {LocalizedString} */ ("Allows members to add custom emojis, stickers and sounds in this server.")
});